import { getCurrencySymbol, getDisplayCurrencyCode } from "@/shared/config/localisation";
import { App_Url } from "@/whiteLable";
const CurrencySymbol = ({ currency, value }) => {
  // console.log("CurrencySymbol::", { currency, value });
  const isNumeric =
    (typeof value === "number" && !isNaN(value)) ||
    (typeof value === "string" && /^[+-]?\d+(\.\d+)?$/.test(value.trim()));
  if (!currency || !isNumeric) return null;

  const normalizedCurrency = getDisplayCurrencyCode(currency);
  const symbol = getCurrencySymbol(currency);

  if (normalizedCurrency === "AED") {
    return <img src={App_Url.partners.symbols.Aed} alt="AED" className="h-3 w-auto inline-block" />;
  }

  return <span className="">{symbol}</span>;
};

export default CurrencySymbol;
